<app-navbar *ngIf="!isPatientPortalRoute"></app-navbar>
<router-outlet>
</router-outlet>
<app-footer *ngIf="!isPatientPortalRoute" ></app-footer>